//@ts-check

/**
 * Array of `[name, code]` tuples
 */
export const facias = [
    ['JD Sports', 'jd'],
    ['Size?', 'sz'],
    ['Footpatrol', 'fp'],
    ['Tessuti', 'te'],
    ['Millets', 'ml'],
    ['Blacks', 'bl'],
    ['Ultimate Outdoors', 'uo'],
    ['First Sports', 'fs'],
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const faciaNames = facias.map(([name, code]) => name);
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const faciaCodes = facias.map(([name, code]) => code);

export const getFaciaCode = faciaName => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const facia = facias.find(([name, code]) => name === faciaName) || [];
    return facia[1];
};

export const getFaciaName = faciaCode => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const facia = facias.find(([name, code]) => code === faciaCode) || [];
    return facia[0];
};
